/* TARIGANO: start background videos only after page load and only when visible.
   Videos below the fold wait for a real user interaction (scroll/touch/click) first. */
(function () {
  var conn = navigator.connection || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (conn.saveData || reduce) return; // keep posters only

  function activate(v) {
    if (v.dataset.tgActive) return;
    v.dataset.tgActive = '1';
    var srcs = v.querySelectorAll('source[data-src]');
    if (!srcs.length) return;
    srcs.forEach(function (s) { s.src = s.dataset.src; });
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      // hidden duplicates (e.g. desktop video on mobile) have no layout box
      if (e.isIntersecting && v.getClientRects().length) { activate(v); io.unobserve(v); }
    });
  }, { rootMargin: '300px 0px' }) : null;

  function watch(v) { io ? io.observe(v) : (v.getClientRects().length && activate(v)); }

  function start() {
    var later = [];
    document.querySelectorAll('video[data-tg-lazy-video]').forEach(function (v) {
      var r = v.getBoundingClientRect();
      if (r.top < window.innerHeight) watch(v); else later.push(v);
    });
    if (!later.length) return;
    var evts = ['scroll', 'touchstart', 'pointerdown', 'keydown', 'wheel'];
    function onFirst() {
      evts.forEach(function (n) { window.removeEventListener(n, onFirst, true); });
      later.forEach(watch);
    }
    evts.forEach(function (n) { window.addEventListener(n, onFirst, { capture: true, passive: true }); });
  }

  if (document.readyState === 'complete') setTimeout(start, 0);
  else window.addEventListener('load', function () { setTimeout(start, 0); });
})();
